import { get } from 'lodash';
import { mapActions, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';

export default {
  mixins: [loaderMixin],
  props: {
    obj: Object,
    category: String,
    disabled: Boolean,
    localOnly: { type: Boolean, default: false },
    localValue: { type: [String, Number, Boolean], default: undefined },
  },
  emits: ['change', 'error'],
  data() {
    return {
      modelValue: null,
      oldValue: null,
    };
  },
  watch: {
    localValue(value) {
      if (this.localOnly) {
        this.modelValue = value ?? this.obj.defaultValue;
        this.oldValue = this.modelValue;
      }
    },
  },
  computed: {
    ...mapState('profile', ['settings']),
    classObject() {
      return {
        'settings-option-switch': true,
        'settings-option-switch--disabled': this.disabled,
      };
    },
    isDisabled() {
      return this.disabled;
    },
  },
  methods: {
    ...mapActions('profile', ['updateSettings']),
    isOptionDisabled(option) {
      return this.isDisabled || !!option.disabled;
    },
    change(value) {
      if (this.localOnly) {
        if (this.isDisabled) return;
        this.modelValue = value;
        this.oldValue = value;
        this.$emit('change', value);
        return;
      }
      this.loaderAddLegacy();
      this.modelValue = value;
      this.updateSettings({
        category: this.category,
        key: this.obj.key,
        value,
      })
        .then(() => {
          this.oldValue = this.modelValue;
          this.loaderRemoveLegacy();
        })
        .catch(() => {
          this.loaderRemoveLegacy();
          this.modelValue = this.oldValue;
          this.$emit('error', `Could not set "${this.obj.info}"`);
        });
      this.$emit('change', value);
    },
  },
  created() {
    const value = this.localOnly
      ? this.localValue
      : get(this.settings, [this.category, this.obj.key]);
    this.modelValue = value !== undefined ? value : this.obj.defaultValue;
    this.oldValue = this.modelValue;
  },
};
